"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.Site = void 0;
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 * @author Krzysztof Ustowski <krzysztof.ustowski@movecloser.pl>
 */
var Site;
(function (Site) {
    Site["CyberDefence24"] = "cyberdefence24.pl";
    Site["Defence24"] = "defence24.pl";
    Site["Defence24COM"] = "defence24.com";
    Site["Defence24MSPO"] = "mspo.defence24.pl";
    Site["Energetyka24"] = "energetyka24.pl";
    Site["InfoSecurity24"] = "infosecurity24.pl";
    Site["Space24"] = "space24.pl";
    Site["KadeciRP"] = "kadecirp.pl";
})(Site = exports.Site || (exports.Site = {}));
//# sourceMappingURL=site.js.map